import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class LoadingPlanService {
  async fetchloaded(page, pagesize, search) {
    const pageParam = `page=${page}&perPage=${pagesize}`
    let params = search ? `search=${search}` : pageParam;

    const response = await ajaxService.get(
      `/containers?type=loaded&${params}`
    );
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async fetchsaved(page, pagesize, search) {
    const pageParam = `page=${page}&perPage=${pagesize}`
    let params = search ? `search=${search}` : pageParam;

    const response = await ajaxService.get(
      `/containers?type=saved&${params}`
    );
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async View(id, page) {
    const response = await ajaxService.get(`/containers/${id}?page=${page}`);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async ViewPDF(id) {
    const response = await ajaxService.get(`/containers/pdf/${id}`);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async addPlan(data) {
    const response = await ajaxService.post(`/containers`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async updatePlan(id, data) {
    const response = await ajaxService.put(`/containers/`, id, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async updatePlanFrieght(id, data) {
    const response = await ajaxService.post(
      `/containers/update/loadplan-vendors/`,
      data,
      id
    );
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async deletePlan(id) {
    const response = await ajaxService.delete(`/containers/`, id);
    if (response ?? false) {
      return response;
    }
  }

  async fetchClasses() {
    const response = await ajaxService.get(`/shipping-classes`);
    if (response?.success ?? false) {
      return response
    }
  }
  async editShippingClass(data) {
    const response = await ajaxService.post(`/container/update-vehicle-shipping-class`, data);
    if (response?.success ?? false) {
      return response
    } else {
      const errors = response.data.errors;
      return validationErrors(errors)
    }
  }

  async fetchOffload(id) {
    const response = await ajaxService.get(`/containers/offloads/${id}`)
    if (response?.success ?? false) {
      return response
    }
  }

  async sendmail(data) {
    const response = await ajaxService.post(`/containers/send-email`, data)
    if (response?.success ?? false) {
      return response
    } else {
      const errors = response.data.errors;
      return validationErrors(errors)
    }
  }

  /**Customer load plan APIs */
  async fetchCustomerLoadPlan(page, type, search) {
    const params = new URLSearchParams();

    if (type) params.append("type", type);
    if (search) params.append("search", search);

    params.append("page", page);

    const response = await ajaxService.get(`/client-load-plans?${params.toString()}`);

    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }

  // async fetchCustomerLoadPlan(page, type) {
  //   const response = type
  //     ? await ajaxService.get(`/client-load-plans?type=${type}&page=${page}`)
  //     : await ajaxService.get(`/client-load-plans?&page=${page}`);
  //   if (response ?? false) {
  //     return response;
  //   } else {
  //     const errors = response.data.errors;
  //     return validationErrors(errors);
  //   }
  // }
  async addClientPlan(data) {
    const response = await ajaxService.post(`/client-load-plans`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async generatePDF(data, id) {
    const response = await ajaxService.post(`/containers/generatepdf/`, data, id);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async getBLform(id) {
    const response = await ajaxService.get(`/bl-forms/booking/${id}`);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
}

const loadingPlanService = new LoadingPlanService();

export default loadingPlanService;
